<!-- История сохранённых версий ПЛАНа с результатом или причиной ошибки. -->
<template>
  <div class="plan-history">
    <div v-if="changedRows.length" class="plan-history__row plan-history__row--draft">
      <strong class="plan-history__version plan-history__version--draft">v{{ nextVersion }}</strong>
      <span>
        <span class="plan-history__title">Черновик: изменены исходные данные</span>
        <small>{{ changedSummary }} · появится после «Пересчитать»</small>
      </span>
      <span class="plan-history__result plan-history__result--draft">
        <span>—</span>
        <small>не сохранено</small>
      </span>
    </div>
    <div v-for="(calculation, index) in calculations" :key="calculation.id" class="plan-history__row">
      <strong
        class="plan-history__version"
        :class="{ 'plan-history__version--current': calculation.current }"
      >
        v{{ calculation.version }}
      </strong>
      <span>
        {{ title(calculation, index) }}
        <small>{{ calculation.calculated_by?.initials || "—" }} · {{ formatDateAndTime(calculation.calculated_at) }}</small>
      </span>
      <span class="plan-history__result" :class="{ 'plan-history__result--error': calculation.status === 'failed' }">
        <span>{{ historyResult(calculation) }}</span>
        <small>{{ calculation.current ? "текущая" : calculation.status === "failed" ? "ошибка" : "архив" }}</small>
      </span>
    </div>
    <div v-if="hasMore" class="plan-history__more">
      <base-button
        variant="ghost"
        :disabled="isLoadingMore"
        @click="$emit('load-more')"
      >
        {{ isLoadingMore ? "Загрузка…" : "Показать ещё" }}
      </base-button>
    </div>
  </div>
</template>

<script>
import { formatDateAndTime } from "@/utils/dateUtils";
import { formatBigNumber } from "@/utils/numberUtils";
import { getCalculationHistoryTitle } from "@/utils/orderCalculation/historyUtils";

export default {
  name: "OrderPlanCalculationHistory",

  props: {
    calculations: { type: Array, default: () => [] },
    changedRows: { type: Array, default: () => [] },
    nextVersion: { type: Number, required: true },
    hasMore: { type: Boolean, default: false },
    isLoadingMore: { type: Boolean, default: false },
  },

  emits: ["load-more"],

  computed: {
    changedSummary() {
      return this.changedRows
        .map((row) => `${row.name} ${formatBigNumber(row.originalValue)} → ${formatBigNumber(row.value)}`)
        .join(", ");
    },
  },

  methods: {
    title(calculation, index) {
      return getCalculationHistoryTitle(this.calculations, index);
    },
    historyResult(calculation) {
      if (calculation.status === "failed") {
        return calculation.error_details?.join(", ") || "Ошибка расчёта";
      }
      return `${formatBigNumber(calculation.result)} ₽`;
    },
    formatDateAndTime,
  },
};
</script>

<style scoped>
.plan-history {
  display: flex;
  flex-direction: column;
}

.plan-history__row {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border-top: 1px solid #f3f5f9;
  font-size: 14px;
}

.plan-history__row:first-child {
  border-top: 0;
}
.plan-history__row > :nth-child(2) {
  display: flex;
  flex-direction: column;
}
.plan-history__row small {
  color: #4b5068;
  font-size: 11px;
}
.plan-history__row--draft {
  background: #fffbeb;
}
.plan-history__title {
  font-weight: 500;
}

.plan-history__version {
  padding: 2px 0;
  border-radius: 6px;
  background: #e3e8f8;
  color: #4b5068;
  font-size: 12px;
  text-align: center;
}

.plan-history__version--draft {
  background: #fef3c7;
  color: #854d0e;
}
.plan-history__version--current {
  background: #3b5bdb;
  color: #fff;
}

.plan-history__result {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  color: #047a69;
  font-weight: 600;
  text-align: right;
}

.plan-history__result--draft {
  color: #8b93a7;
}
.plan-history__result--draft small {
  font-weight: 400;
}

.plan-history__result--error {
  color: #854d0e;
  font-size: 12px;
}

.plan-history__more {
  display: flex;
  justify-content: center;
  padding: 10px 14px;
  border-top: 1px solid #f3f5f9;
}

@media (max-width: 768px) {
  .plan-history__row {
    grid-template-columns: 40px minmax(0, 1fr);
  }
  .plan-history__result {
    grid-column: 2;
    align-items: flex-start;
    text-align: left;
  }
}
</style>
